<span mat-button mat-dialog-close class="right pointer"><i id="closeOverlay" class="far fa-times-circle"></i></span>
<h1 mat-dialog-title>Note & Note interne</h1>
<div mat-dialog-content>
    <div class="delivery-colle-data-box">
        <fieldset>
            <legend>Note & Note interne</legend>
            <div class="col-48 grid-element">
                <label>Note</label>
                <div>
                    {{ delivery.notes || "---" }}
                </div>
            </div>
            <div class="col-48 grid-element">
                <label>Note interne</label>
                <div>
                    {{ delivery.internalNotes || "---" }}
                </div>
            </div>
        </fieldset>
    </div>
</div>
<div mat-dialog-actions>
    <div>
        <button mat-button mat-dialog-close class="btn">Chiudi</button>
    </div>
</div>